













































import Vue from "vue";

// Vuex
import { mapState } from "vuex";

// Vue components
import DeviceTree from "@/components/DeviceTree/index.vue";

// Model
import { GetBranchInstallationsCommand, GetBranchInstallationsResData } from "@/model/communication/branch/GetBranchInstallationsCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { DeviceTreeNode, FolderDeviceTreeNode, InstallationDeviceTreeNode } from "@/model/data/deviceTree/DeviceTreeNode";
import { DeviceTreeNodeTypeEnum } from "@/model/data/deviceTree/DeviceTreeNodeTypeEnum";
import { EditBranchInstallationsReqData } from "@/model/communication/branch/EditBranchInstallationsReqData";

export default Vue.extend({
    components: {
        DeviceTree,
    },
    data() {
        return {
            DeviceTreeNodeTypeEnum,
            loading: false,
            dialog: false,
            branchInstallationNames: [],
            branchInstallations: [],
        };
    },
    props: ["branch", "isEditMode"],
    computed: {
        ...mapState({
            deviceTree: (state: any) => state.devices.deviceTree,
        }),

        visibleInstallationsCount() {
            return this.branch.visibleInstallationsCount;
        },

        showAlertIcon() {
            return this.visibleInstallationsCount == 0 && this.branch.globalInstallationsCount == 0;
        },
    },
    watch: {
        dialog(value) {
            if (value) this.onOpenDialog();
            else this.onCloseDialog();
            // if (!value) this.branch = {};
            // poi penso che debba anche settare la variabile selectedDevices = {}
        },

        branchInstallationNames(newValue) {
            var checkNode = function (node: DeviceTreeNode, initialValues: any) {
                if (node.type == DeviceTreeNodeTypeEnum.Device) {
                    initialValues.forEach((initialValue) => {
                        if (node.id == initialValue || node.name == initialValue) {
                            var temp: InstallationDeviceTreeNode = new InstallationDeviceTreeNode(null);
                            temp.id = node.id;
                            temp.type = node.type;
                            temp.name = node.name;
                            temp.license = (node as InstallationDeviceTreeNode).license;
                            completeNodes.push(temp);
                        }
                    });
                } else if (node.type == DeviceTreeNodeTypeEnum.Folder && (node as FolderDeviceTreeNode).children && (node as FolderDeviceTreeNode).children.length > 0) {
                    (node as FolderDeviceTreeNode).children.forEach((childNode) => {
                        checkNode(childNode, initialValues);
                    });
                }

                return null;
            };

            if (newValue && newValue.length > 0) {
                var completeNodes = [];
                this.deviceTree.forEach((node: DeviceTreeNode) => {
                    checkNode(node, newValue);
                });

                this.branchInstallations = completeNodes;
            }
        },
    },
    methods: {
        onOpenDialog() {
            this.getBranchInstallations();
        },

        onCloseDialog() {
            this.branchInstallationNames = [];
            this.branchInstallations = null;
        },

        async onSave() {
            var req: EditBranchInstallationsReqData = new EditBranchInstallationsReqData(
                this.branchInstallations ? this.branchInstallations.filter((d) => d.type == DeviceTreeNodeTypeEnum.Device).map((d) => d.name) : [],
                this.branch.id
            );

            this.$emit("edit-installations", req);
            this.dialog = false;
        },

        async getBranchInstallations() {
            try {
                this.loading = true;
                var res: GetBranchInstallationsResData = await new GetBranchInstallationsCommand(this.branch.id).execute();
                this.loading = false;

                if (res.responseStatus == ApiResponseStatusEnum.Success) {
                    this.branchInstallationNames = res.installationNames;
                } else console.error("Error executing GetBranchInstallationsCommand");
            } catch (e) {
                console.error("Error executing GetBranchInstallationsCommand");
                this.loading = false;
            }
        },
    },
});
